import { MavPlusTable } from './mav-plus-table';

export { MavPlusTable };
